import React from 'react'
import Guestdetails from './DOMguestdetails/guestdetails'
import RegGuestDetails from './RegGuestdetails'
function GuestDetailsIndex(props) {
    var occtype = props.guestdetails.occupancyType
  return (
    <div>{occtype == 'Regular' ? (<RegGuestDetails TotalAmountByGuest={props.TotalAmountByGuest} guestdetails={props.guestdetails} GuestDueAmount={props.GuestDueAmount}/>) : (<></>)}
    {occtype !== 'Regular' && props.guestdetails.guestStatus == 'active' ? (<Guestdetails TotalAmountByGuest={props.TotalAmountByGuest} guestdetails={props.guestdetails} GuestDueAmount={props.GuestDueAmount} />):(<></>)}
    </div>
  )
}
export default GuestDetailsIndex